// data.jsx
import { supabase } from '../../supabaseClient'; // Perbaiki path importnya

// Fungsi untuk mengambil data proyek dari Supabase
export const fetchProjectsData = async () => {
  const { data, error } = await supabase
    .from('testimonials') // Nama tabel yang kamu buat di Supabase
    .select('*'); // Mengambil semua kolom dari tabel 'projects'

  if (error) {
    console.error('Error fetching projects:', error);
    return [];
  }
  return data; // Mengembalikan data proyek
};

// Mengambil status proyek (misalnya)
// export const fetchStatus = async () => {
//   const { data, error } = await supabase
//     .from('projects') // Nama tabel yang kamu buat di Supabase
//     .select('status') // Mengambil hanya kolom status
//     .single(); // Mengambil satu baris saja

//   if (error) {
//     console.error('Error fetching status:', error);
//     return null;
//   }
//   return data.status; // Mengembalikan status
// };
